import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import EmployeeView from './pages/EmployeeView';
import AddEmployee from './pages/AddEmployee';
import Settings from './pages/Settings';
import PaySlip from './pages/PaySlip';
import PaySlipList from './pages/payslip/PaySlipList';
import ImportPaySlip from './pages/payslip/ImportPaySlip';
import SendPaySlip from './pages/payslip/SendPaySlip';
import PaySlipView from './pages/payslip/PaySlipView';
import BankSettings from './pages/settings/BankSettings';
import UserSettings from './pages/settings/UserSettings';
import UserEdit from './pages/settings/UserEdit';
import OutletSettings from './pages/settings/OutletSettings';
import RoleSettings from './pages/settings/RoleSettings';
import DesignationSettings from './pages/settings/DesignationSettings';
import ShiftSettings from './pages/settings/ShiftSettings';
import DocumentSettings from './pages/settings/DocumentSettings';
import UniformTypeSettings from './pages/settings/UniformTypeSettings';
import Files from './pages/Files';
import FilesFormView from './pages/FilesFormView';
import FileNameManager from './pages/FileNameManager';
import Resume from './pages/Resume';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import EmployeeForgotPassword from './pages/EmployeePasswordResetFlow';
import Logout from './pages/Logout';
import ProtectedRoute from './components/ProtectedRoute';
import EmployeeProtectedRoute from './components/EmployeeProtectedRoute';
import SuggestionsComplaints from './pages/SuggestionsComplaints';
import EmployeeRegister from './pages/EmployeeRegister';
import EmployeeRegisterSuccess from './pages/EmployeeRegisterSuccess';
import PendingEmployeeApprovals from './pages/PendingEmployeeApprovals';
import PendingEmployeeApprovalView from './pages/PendingEmployeeApprovalView';
import Notifications from './pages/Notifications';
import Alerts from './pages/Alerts';
import EmployeeMobileLogin from './pages/EmployeeMobileLogin';
import EmployeeMobileDetails from './pages/EmployeeMobileDetails';
import EmployeeLoginList from './pages/EmployeeLoginList';
import EmployeeLoginCreate from './pages/EmployeeLoginCreate';
import Reports from './pages/Reports';
import EmployeeExport from './pages/EmployeeExport';
import EmployeeOverview from './pages/EmployeeOverview';
import CompanyDetails from './pages/CompanyDetails';
import NotFound from './pages/NotFound';
import CompanySelection from './pages/CompanySelection';
import AccessDenied from './pages/AccessDenied';
import PermissionBoundary from './components/PermissionBoundary';
import StoreUserList from './pages/storeUsers/StoreUserList';
import StoreUserForm from './pages/storeUsers/StoreUserForm';
import StoreLogin from './pages/store/StoreLogin';
import StoreLayout from './pages/store/StoreLayout';
import StoreDashboard from './pages/store/StoreDashboard';
import StoreChangePassword from './pages/store/StoreChangePassword';
import StoreActiveEmployeeList from './pages/store/employees/StoreActiveEmployeeList';
import StoreUniformFormList from './pages/store/uniform/StoreUniformFormList';
import StoreUniformFormCreateEdit from './pages/store/uniform/StoreUniformFormCreateEdit';
import StoreUniformFormView from './pages/store/uniform/StoreUniformFormView';
import StoreUniformEmployeeView from './pages/store/uniform/StoreUniformEmployeeView';
import StoreFiles from './pages/store/documents/StoreFiles';
import StoreFilesFormView from './pages/store/documents/StoreFilesFormView';
import UniformFormList from './pages/uniform/UniformFormList';
import UniformFormView from './pages/uniform/UniformFormView';
import UniformFormEdit from './pages/uniform/UniformFormEdit';
import UniformProvidedCreate from './pages/uniform/UniformProvidedCreate';
import StoreProtectedRoute from './components/store/StoreProtectedRoute';
import SalaryStatementList from './pages/salaryStatement/SalaryStatementList';
import SalaryStatementUpload from './pages/salaryStatement/SalaryStatementUpload';
import SalaryStatementPreview from './pages/salaryStatement/SalaryStatementPreview';
import StoreSalaryStatementList from './pages/store/salaryStatement/StoreSalaryStatementList';
import StoreSalaryStatementPreview from './pages/store/salaryStatement/StoreSalaryStatementPreview';
import OfferLetterList from './pages/offerLetters/OfferLetterList';
import OfferLetterTemplateList from './pages/offerLetters/OfferLetterTemplateList';
import OfferLetterTemplateForm from './pages/offerLetters/OfferLetterTemplateForm';
import OfferLetterGenerate from './pages/offerLetters/OfferLetterGenerate';
import OfferLetterPreview from './pages/offerLetters/OfferLetterPreview';
import AttendanceSyncPage from './pages/attendance/AttendanceSyncPage';
import AttendanceInOutPage from './pages/attendance/AttendanceInOutPage';
import AttendanceNoPunchPage from './pages/attendance/AttendanceNoPunchPage';
import EmployeeMonthlyAttendancePage from './pages/attendance/EmployeeMonthlyAttendancePage';


const SETTINGS_ACCESS_KEYS = [
  'settings',
  'settings-bank',
  'settings-user',
  'settings-outlet',
  'settings-designation',
  'settings-shift',
  'settings-document',
  'settings-uniform-type',
  'role_management',
  'master',
  'master.companies',
];

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/store-login" element={<StoreLogin />} />
        <Route element={<StoreProtectedRoute />}>
          <Route path="/store" element={<StoreLayout />}>
            <Route path="dashboard" element={<StoreDashboard />} />
            <Route path="employees" element={<StoreActiveEmployeeList />} />
            <Route path="uniform-forms" element={<StoreUniformFormList />} />
            <Route path="uniform-forms/add" element={<StoreUniformFormCreateEdit />} />
            <Route path="uniform-forms/add/:employeeId" element={<StoreUniformFormCreateEdit />} />
            <Route path="uniform-forms/employee/:employeeId" element={<StoreUniformEmployeeView />} />
            <Route path="uniform-forms/edit/:id" element={<StoreUniformFormCreateEdit />} />
            <Route path="uniform-forms/view/:id" element={<StoreUniformFormView />} />
            <Route path="files" element={<StoreFiles />} />
            <Route path="files/:folderId" element={<StoreFilesFormView />} />
            <Route path="change-password" element={<StoreChangePassword />} />
            <Route path="salary-statements" element={<StoreSalaryStatementList />} />
            <Route path="salary-statements/:id" element={<StoreSalaryStatementPreview />} />
          </Route>
        </Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/employee/mobile/login" element={<EmployeeMobileLogin />} />
        <Route path="/employee/forgot-password" element={<EmployeeForgotPassword />} />
        <Route element={<EmployeeProtectedRoute />}>
          <Route path="/employee/mobile/details" element={<EmployeeMobileDetails />} />
          <Route path="/employee/register" element={<EmployeeRegister />} />
          <Route path="/employee/register/success" element={<EmployeeRegisterSuccess />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path="/select-company" element={<CompanySelection />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={(
              <PermissionBoundary moduleKey="dashboard">
                <Dashboard />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/complaints"
            element={(
              <PermissionBoundary moduleKey="approvals.complaints">
                <SuggestionsComplaints />
              </PermissionBoundary>
            )}
          />

          <Route
            path="/dashboard/alerts"
            element={(
              <PermissionBoundary moduleKey="notifications">
                <Alerts />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/notifications"
            element={(
              <PermissionBoundary moduleKey="notifications">
                <Notifications />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/employee-logins"
            element={(
              <PermissionBoundary moduleKey="employee.mobile_logins">
                <EmployeeLoginList />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/employee-logins/new"
            element={(
              <PermissionBoundary moduleKey="employee.mobile_logins" action="create">
                <EmployeeLoginCreate />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/pending-approvals"
            element={(
              <PermissionBoundary moduleKey="approvals.pending">
                <PendingEmployeeApprovals />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/companies"
            element={(
              <PermissionBoundary moduleKey="master.companies">
                <CompanyDetails />
              </PermissionBoundary>
            )}
          />

          <Route
            path="/uniform-forms"
            element={(
              <PermissionBoundary moduleKey="uniform-forms">
                <UniformFormList />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/uniform-forms/provided/add"
            element={(
              <PermissionBoundary moduleKey="uniform-forms" actions={['create']}>
                <UniformProvidedCreate />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/uniform-forms/view/:id"
            element={(
              <PermissionBoundary moduleKey="uniform-forms">
                <UniformFormView />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/uniform-forms/edit/:id"
            element={(
              <PermissionBoundary moduleKey="uniform-forms" actions={['edit']}>
                <UniformFormEdit />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/store-users"
            element={(
              <PermissionBoundary moduleKey="store_users">
                <StoreUserList />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/store-users/add"
            element={(
              <PermissionBoundary moduleKey="store_users" actions={['create', 'edit']}>
                <StoreUserForm />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/store-users/edit/:id"
            element={(
              <PermissionBoundary moduleKey="store_users" actions={['edit']}>
                <StoreUserForm />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/employee-logins"
            element={(
              <PermissionBoundary moduleKey="employee.mobile_logins">
                <EmployeeLoginList />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/employee-logins/new"
            element={(
              <PermissionBoundary moduleKey="employee.mobile_logins" action="create">
                <EmployeeLoginCreate />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/pending-approvals/:id"
            element={(
              <PermissionBoundary moduleKey="approvals.pending">
                <PendingEmployeeApprovalView />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/dashboard/employees/:employeeId/approval-view"
            element={(
              <PermissionBoundary moduleKey="approvals.pending">
                <PendingEmployeeApprovalView source="employee" />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/employees"
            element={(
              <PermissionBoundary moduleKey="employee.list">
                <Employees />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/employees/:id"
            element={(
              <PermissionBoundary moduleKey="employee.view">
                <EmployeeView />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/add-employee"
            element={(
              <PermissionBoundary moduleKey="employee.create_edit" action="create">
                <AddEmployee />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/reports"
            element={(
              <PermissionBoundary moduleKey={['reports', 'reports.overview', 'reports.employee_export']}>
                <Reports />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/reports/export/employees"
            element={(
              <PermissionBoundary moduleKey="reports.employee_export" action="view">
                <EmployeeExport />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/reports/overview"
            element={(
              <PermissionBoundary moduleKey="reports.overview">
                <EmployeeOverview />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/payslip"
            element={(
              <PermissionBoundary moduleKey={['payslip.dashboard', 'payslip.list', 'payslip.import', 'payslip.send', 'payslip.view']}>
                <PaySlip />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/payslip/list"
            element={(
              <PermissionBoundary moduleKey="payslip.list">
                <PaySlipList />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/payslip/import"
            element={(
              <PermissionBoundary moduleKey="payslip.import" action="create">
                <ImportPaySlip />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/payslip/send"
            element={(
              <PermissionBoundary moduleKey="payslip.send" action="create">
                <SendPaySlip />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/payslip/view"
            element={(
              <PermissionBoundary moduleKey="payslip.view">
                <PaySlipView />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings"
            element={(
              <PermissionBoundary moduleKey={SETTINGS_ACCESS_KEYS}>
                <Settings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/bank"
            element={(
              <PermissionBoundary moduleKey="settings-bank">
                <BankSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/users"
            element={(
              <PermissionBoundary moduleKey="settings-user">
                <UserSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/users/:id"
            element={(
              <PermissionBoundary moduleKey="settings-user" action="edit">
                <UserEdit />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/outlet"
            element={(
              <PermissionBoundary moduleKey="settings-outlet">
                <OutletSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/roles"
            element={(
              <PermissionBoundary moduleKey="role_management">
                <RoleSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/designation"
            element={(
              <PermissionBoundary moduleKey="settings-designation">
                <DesignationSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/shifts"
            element={(
              <PermissionBoundary moduleKey="settings-shift">
                <ShiftSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/documents"
            element={(
              <PermissionBoundary moduleKey="settings-document">
                <DocumentSettings />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/settings/uniform-types"
            element={(
              <PermissionBoundary moduleKey="settings-uniform-type">
                <UniformTypeSettings />
              </PermissionBoundary>
            )}
          />
          <Route path="/salary-statements" element={<PermissionBoundary moduleKey="salary_statement"><SalaryStatementList /></PermissionBoundary>} />
          <Route path="/offer-letters/templates/add" element={<PermissionBoundary moduleKey="offer_letters" action="create"><OfferLetterTemplateForm /></PermissionBoundary>} />
          <Route path="/offer-letters/templates/edit/:id" element={<PermissionBoundary moduleKey="offer_letters" action="edit"><OfferLetterTemplateForm /></PermissionBoundary>} />
          <Route path="/offer-letters/templates" element={<PermissionBoundary moduleKey="offer_letters"><OfferLetterTemplateList /></PermissionBoundary>} />
          <Route path="/offer-letters/generate" element={<PermissionBoundary moduleKey="offer_letters" action="create"><OfferLetterGenerate /></PermissionBoundary>} />
          <Route path="/offer-letters/:id/preview" element={<PermissionBoundary moduleKey="offer_letters"><OfferLetterPreview /></PermissionBoundary>} />
          <Route path="/offer-letters" element={<PermissionBoundary moduleKey="offer_letters"><OfferLetterList /></PermissionBoundary>} />
          <Route path="/attendance" element={<PermissionBoundary moduleKey="attendance"><AttendanceSyncPage /></PermissionBoundary>} />
          <Route path="/attendance-in-out" element={<PermissionBoundary moduleKey="attendance_report"><AttendanceInOutPage /></PermissionBoundary>} />
          <Route path="/attendance-no-punch" element={<PermissionBoundary moduleKey="attendance_no_punch"><AttendanceNoPunchPage /></PermissionBoundary>} />
          <Route path="/attendance-calendar/:employeeId" element={<PermissionBoundary moduleKey="attendance_report"><EmployeeMonthlyAttendancePage /></PermissionBoundary>} />
          <Route path="/salary-statements/upload" element={<PermissionBoundary moduleKey="salary_statement" action="create"><SalaryStatementUpload /></PermissionBoundary>} />
          <Route path="/salary-statements/:id" element={<PermissionBoundary moduleKey="salary_statement"><SalaryStatementPreview /></PermissionBoundary>} />
          <Route
            path="/files"
            element={(
              <PermissionBoundary moduleKey="employee.files">
                <Files />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/files/:folderId"
            element={(
              <PermissionBoundary moduleKey="employee.files">
                <FilesFormView />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/files/names"
            element={(
              <PermissionBoundary moduleKey="employee.files">
                <FileNameManager />
              </PermissionBoundary>
            )}
          />
          <Route
            path="/resume"
            element={(
              <PermissionBoundary moduleKey="employee.resume">
                <Resume />
              </PermissionBoundary>
            )}
          />
          <Route path="/logout" element={<Logout />} />
        </Route>
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
